module.exports = __webpack_public_path__ + "img/95.96ff6fa3.webp";